module.exports = __webpack_public_path__ + "static/media/conference-center.f9afb777.svg";